import type { WModuleView } from '@zola/svc-web-api-ts-client';
import { connect } from 'react-redux';

import mapNavTypeToModule from 'util/mapNavTypeToModule';
import { getModuleGroups } from 'selectors/ModuleGroupSelectors';
import { RootState } from 'reducers/index';
import { PrimaryNavIdentifier } from '@zola-helpers/client/dist/es/constants/navConstants';

import NavMarketingModules from './NavMarketingModules';

export type NavMarketingModulesMapStateProps = {
  marketingModules: WModuleView[];
};

export type NavMarketingModulesOwnProps = {
  activeNavType: PrimaryNavIdentifier;
};

export const mapStateToProps = (
  state: RootState,
  ownProps: NavMarketingModulesOwnProps
): NavMarketingModulesMapStateProps => {
  const { activeNavType } = ownProps;
  const views = getModuleGroups(state);
  return {
    marketingModules: mapNavTypeToModule(views, activeNavType),
  };
};

export default connect(mapStateToProps)(NavMarketingModules);
